function parseSvgString(svgString) {
  const div = document.createElement("div");
  div.innerHTML = svgString.trim();
  return div.firstChild;
}
export {
  parseSvgString
};
//# sourceMappingURL=parseSvgString.js.map
